import { defineApi } from '@/utils/fetch';

import type {
    IConfirmPurchaseParams,
    IGetBookDetailResponse,
    IGetChapterDetailParams,
    IGetChapterDetailResponse,
    IGetChapterDetailV2Params,
    IGetChapterDetailV2Response,
    IGetEndDramaListParams,
    IGetEndDramaListResponse,
} from './typings';

export const ReaderApi = {
    /** 获取章节详情（drama_id 必填，chapter_id 可选；省略时服务端返回最近阅读章节或首章） */
    getChapterDetail: defineApi<IGetChapterDetailParams, IGetChapterDetailResponse>({
        url: '/video/video_model/v1/',
        method: 'GET',
    }),

    /** 获取章节详情 V2（仅需 prmt_code，不需要 drama_id / chapter_id） */
    getChapterDetailV2: defineApi<IGetChapterDetailV2Params, IGetChapterDetailV2Response>({
        url: '/video/chapter/v1/',
        method: 'GET',
        requiresAuth: false,
    }),

    getBookDetail: defineApi<{ drama_id: string }, IGetBookDetailResponse>({
        url: '/video/video_detail/v1/',
        method: 'GET',
    }),
    // 用户勾选自动扣除币后，确认购买
    confirmPurchase: defineApi<{ drama_id: string; chapter_id: string }, IConfirmPurchaseParams>({
        url: '/trade/purchase/v1/',
        method: 'POST',
    }),
    // 更新用户信息
    updateUserInfo: defineApi<{ auto_unlock_status: boolean }, IConfirmPurchaseParams>({
        url: '/user/set/profile/v1',
        method: 'POST',
    }),
    // 历史记录
    postHistory: defineApi<
        {
            drama_id: number;
            drama_id_string: string;
            chapter_id: number;
            chapter_id_string: string;
            current_time: number;
            unlocked_reason: number;
        },
        undefined
    >({
        url: '/bookshelf/history/report',
        method: 'POST',
    }),
    fetchEndDramaList: defineApi<IGetEndDramaListParams, IGetEndDramaListResponse>({
        url: '/drama_mall/feeds',
        method: 'GET',
    }),
};

export * from './typings';
